/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Kinds of content identifier a playback can be started from.
 *
 * The same id string means different things depending on its kind — a
 * content, an offer or a unified collection — and each resolves through a
 * different endpoint, so an id is only meaningful together with its kind.
 * Used by VOD today to pick the action-details endpoint.
 *
 * Implemented as const object + type for type-safe string literal union.
 */
export const IdType = {
  /**
   * A content id (`tivo:ct.*`), e.g. VOD `vodOttActionDetails/content/{id}`.
   */
  CONTENT: "content",

  /**
   * An offer id (`tivo:of.*`), e.g. VOD `vodOttActionDetails/offer/{id}`.
   */
  OFFER: "offer",

  /**
   * A unified collection id (`tivo:cl.*`), e.g. VOD
   * `vodOttActionDetails/unifiedCollection/{id}`.
   */
  UNIFIED_COLLECTION: "unifiedCollection"
} as const;

/**
 * Type representing valid IdType values.
 */
export type IdType = (typeof IdType)[keyof typeof IdType];
